import "../css/index.scss";
import $ from "jquery/dist/jquery";

//import "bootstrap/dist/js/bootstrap.bundle";
import "@nxcms/nxcms-js/src/js/sentry";

import "@nxcms/nxcms-js/src/js/static/bootstrap_5";
import "@nxcms/nxcms-js/src/js/static";
import "@nxcms/nxcms-js/src/js/gdpr";
import "@nxcms/nxcms-js/src/js/blog";

import { startTextSwitching, startAnimation } from "./animations";
Object.assign(window, { startTextSwitching, startAnimation });

window.jQuery = window.$ = $;
